import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { LoadCanBrowseLegacyExternalNetworksAction } from '../../domains/canBrowseLegacyExternalNetworks/actions.types';

import type { CanBrowseLegacyExternalNetworks } from './types';

export type { LoadCanBrowseLegacyExternalNetworksAction } from '../../domains/canBrowseLegacyExternalNetworks/actions.types';

const initialState: CanBrowseLegacyExternalNetworks = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<CanBrowseLegacyExternalNetworks, LoadCanBrowseLegacyExternalNetworksAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'CURRENT_USER.LOAD_CAN_BROWSE_LEGACY_EXTERNAL_NETWORKS_PENDING': {
      return setPending();
    }
    case 'CURRENT_USER.LOAD_CAN_BROWSE_LEGACY_EXTERNAL_NETWORKS_FULFILLED': {
      return setFulfilled(action.payload);
    }
    case 'CURRENT_USER.LOAD_CAN_BROWSE_LEGACY_EXTERNAL_NETWORKS_REJECTED': {
      return setRejected(action.payload.error);
    }
    default:
      return state;
  }
};

export default reducer;
